import(/* webpackMode: "eager" */ "/vercel/path0/apps/ocnc/app/prizes/page.tsx");
